<template>
    <v-footer
    :fixed="fixed"
    padless
    class="hfooter grey darken-4"
    v-if="$vuetify.breakpoint.smAndUp"
    >
        <v-card
          width="100%"
          flat
          tile
          class="grey darken-4 white--text text-center"
        >
                    <v-row 
                    align="start"
                    justify="space-between"
                    class="full-screen2 ma-0"
                    >
                    
                        <v-col cols="2" sm="4" md="3" lg="3" xl="3"  class="bottom-slide pa-0 ml-0" v-if="$vuetify.breakpoint.smAndUp">
                          <p class="white--text text-left ml-3 mb-0">Мобильное приложение:</p> 
                          <v-row align="start" justify="start" class="ml-2 mt-5">
                            <v-col cols="3"  class="cursor-url  pa-0 d-flex justify-start"  >
                              <img src="@/assets/android_play.png" class="social-ico icon-url" @click="gotoExtUrl('https://play.google.com/store/apps/details?id=org.navimind.gagarin')" key="andr"/>
                              <img src="@/assets/apple_appstore.png" class="social-ico icon-url" @click="gotoExtUrl('')" key="ios"/>
                              </v-col>

                          </v-row>
                        </v-col>
                        <v-col cols="2" class="bottom-slide pa-0 mr-4"  v-if="$vuetify.breakpoint.xs">
                        </v-col>                        
                        <v-col cols="2" sm="3" md="3" lg="3" xl="3" class="bottom-slide">
                          <v-btn 
                          class="ma-2 btn-round-border" 
                          fab     
                          outlined                      
                          x-large                            
                          color="#fff" 
                          @click="scrollToEl"
                          >
                            <v-icon light>mdi-chevron-up</v-icon>
                          </v-btn> 
                        </v-col>
                        <v-col cols="2" class="bottom-slide pa-0 mr-4"  v-if="$vuetify.breakpoint.xs">
                        </v-col>
                        <v-col cols="2" sm="4" md="3" lg="3" xl="3"  class="bottom-slide pa-0 mr-0"  v-if="$vuetify.breakpoint.smAndUp && dataAdmin!==null">
                                <p class="white--text text-right my-0 mr-3">Мы в социальных сетях:</p> 
                                <v-row justify="center" align="center"  class="mr-2 mt-5">
                                  <v-col cols="12" class="pa-0 d-flex justify-end">

                                      <img  v-for="(itemIcon,ii) in dataAdmin.settings.sn"
                                      :key="`isc-`+ii" :src="itemIcon.file" class="social-ico icon-url cursor-url"  @click="gotoSocial(itemIcon.link)"/>

                                  </v-col>
                                </v-row>
                                
                        </v-col>
                    </v-row>



      <v-divider></v-divider>
      <v-card-text class="white--text">
        &copy; ТРЦ «Гагаринский» в Москве. 2009-{{ new Date().getFullYear() }} гг
      </v-card-text>
    </v-card>
    </v-footer>
</template>
<script>
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default {
  name: 'Footer',
  data () {
    return {
        type: 'number',
        number: 9999,
        selector: 0,
        duration: 600,
        offset: 0,
        easing: 'easeInOutCubic',
        topID: null,
        fixed: false,
      socialLinks:[
        {
        title: 'Facebook',
        link: '',
        icon: require('@/assets/smm_fb1.png')
        },
        {
        title: 'Instagramm',
        link: '',
        icon: require('@/assets/smm_insta1.png')
        },
        {
        title: 'Одноклассники',
        link: '',
        icon: require('@/assets/smm_ok1.png')
        },
        {
        title: 'Telegramm',
        link: '',
        icon: require('@/assets/smm_tel1.png')
        },
        {
        title: 'Twitter',
        link: '',
        icon: require('@/assets/smm_tw1.png')
        },
        {
        title: 'Вконтакте',
        link: '',
        icon: require('@/assets/smm_vk1.png')
        },
      ],
      
    }
  },
    computed: {
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },      
    dataAdmin:{
      get () {
        return this.$store.getters.getDataAdmin;
      },
     
    },       
      target () {
        const value = this.selector
        if (!isNaN(value)) return Number(value)
        else return value
      },
      options () {
        return {
          duration: this.duration,
          offset: this.offset,
          easing: this.easing,
        }
      },

    },
    methods:{
      gotoExtUrl(urlSocial){
        if(DEBUG) console.log('urlSocial :>> ', urlSocial);
        var win = window.open(urlSocial, '_blank');
        win.focus();       
        //window.location = urlSocial;
      
      },      
      gotoSocial(urlSocial){
        if(DEBUG) console.log('urlSocial :>> ', urlSocial);
        var win = window.open(urlSocial, '_blank');
        win.focus();       
        //window.location = urlSocial;
      
      },

      scrollToEl(e){
        let vApp = this;
        if(DEBUG) console.log('Scroll e :', e);       
      let scrollEl = document.querySelector('#scrollT');
      let scrollElH = document.querySelector('#first');
      if(scrollEl!== null){
         if(DEBUG) console.log('scrollEl :', scrollEl);  
      scrollEl.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        }); 


      }
      else{
        if(DEBUG) console.log('scrollElH :', scrollElH);  
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
              });    
      }
 
      },

    },
      mounted () {    
    if(DEBUG) console.log('mounted Home = ', this)
    let vApp = this
    this.$nextTick(function () {
      vApp.topID = document.getElementById('start');
      if(DEBUG) console.log('vApp.topID :', vApp.topID);
    });
      },
}
</script>
<style  scoped>
.hfooter{
  height: 20vh;
}
.btn-round-border{
  border: 0px solid #fff;
}

</style>